import { useState, useEffect } from 'react'
import { PayPeriodResponse } from '../../models/enhancement'
import { enhancementService } from '../../services/enhancementService'
import { useDefaultErrorHandler } from './useDefaultErrorHandler'

export const usePayPeriod = (employeeId?: number | null) => {
  const defaultErrorHandler = useDefaultErrorHandler()

  const [payPeriod, setPayPeriod] = useState<PayPeriodResponse>()

  /**
   *get the pay period
   */
  useEffect(() => {
    if (employeeId === null) {
      return
    }

    enhancementService
      .getCurrentPayPeriod(employeeId ?? undefined)
      .then(payPeriodResponse => {
        setPayPeriod(payPeriodResponse)
      })
      .catch(err => {
        defaultErrorHandler(err)
      })
  }, [employeeId])

  return payPeriod
}
